import { v4 as uuidV4 } from 'uuid';
import Api from './api';
import { logErrorsAndExceptions } from './logger';

let sessionId = uuidV4();
let pendingMetrics = [];
const aggregationInterval = 1000 * 30;
let intervalId;

export const Measurements = {
  COMPARISON_ENABLED: 'COMPARISON_ENABLED',
  COMPARISON_DISABLED: 'COMPARISON_DISABLED',
  DATE_RANGE_APPLIED: 'DATE_RANGE_APPLIED',
  DATE_RANGE_CANCELED: 'DATE_RANGE_CANCELED',

  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_PUBLISHED:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_PUBLISHED',
  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_DUPLICATED:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_DUPLICATED',
  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_TO_DRAFT:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_TO_DRAFT',
  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_TO_CREATE:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_TO_CREATE',
  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_DELETED:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_DELETED',
  CLIENT_DOCUMINE_QUESTION_BANK_USECASE_OPENED:
    'CLIENT_DOCUMINE_QUESTION_BANK_USECASE_OPENED',
  CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_PUBLISHED:
    'CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_PUBLISHED',
  CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_DUPLICATED:
    'CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_DUPLICATED',
  CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_TO_DRAFT:
    'CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_TO_DRAFT',
  CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_OPENED:
    'CLIENT_DOCUMINE_QUESTION_BANK_DS_USECASE_OPENED',
  CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_PUBLISHED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_PUBLISHED',
  CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_TO_DRAFT:
    'CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_TO_DRAFT',
  CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_DELETED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_USECASE_DELETED',
  CLIENT_DOCUMINE_MANAGE_USECASE_SINGLE_QUESTION_ADDED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_SINGLE_QUESTION_ADDED',
  CLIENT_DOCUMINE_MANAGE_USECASE_BULK_QUESTION_ADDED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_BULK_QUESTION_ADDED',
  CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_DELETED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_DELETED',
  CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_MOVED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_MOVED',
  CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_EDITED:
    'CLIENT_DOCUMINE_MANAGE_USECASE_QUESTION_EDITED'
};

/**
 * @typedef {Object} MetricData
 * @property {string} measurement - The measurement type from Measurements
 * @property {number} value - The metric value
 */

/**
 * Adds a metric to the pending metrics queue
 * @param {MetricData} metric - The metric data to add
 */
export function addMetric(metric) {
  pendingMetrics.push({
    timestamp: Date.now(),
    ...metric
  });
}

async function sendMetrics() {
  if (pendingMetrics.length == 0) {
    return;
  }

  const currentMetrics = pendingMetrics;
  pendingMetrics = [];

  try {
    await Api.post('/metrics/new', {
      sessionId,
      metrics: currentMetrics
    });
  } catch (error) {
    logErrorsAndExceptions(sendMetrics.name, error);
    pendingMetrics.push(...currentMetrics);
  }
}

export default function initializeMetrics() {
  // Clear any existing interval
  if (intervalId) {
    clearInterval(intervalId);
  }

  intervalId = setInterval(sendMetrics, aggregationInterval);
}
